import React, { memo, useState } from 'react';
import NewTag from '../RightBar/NewTag';
import NewVendor from '../RightBar/NewVendor';
import NewAccount from '../RightBar/NewAccount';
import AccountResult from './Finder/AccountResult';
import TransactionResult from './Finder/TransactionResult';
import VendorResult from './Finder/VendorResult';
import NewRole from '../RightBar/Config/NewRole';
import UpdateRole from '../RightBar/Config/UpdateRole';
import NewUserInvite from '../RightBar/Config/NewUserInvite';
import NewBank from '../RightBar/NewBank';
import ConfigFeesValue from '../RightBar/Config/ConfigFeesValue';
import SyncStudents from '../RightBar/SchoolFees/SyncStudents';
import NewFeesGroup from '../RightBar/SchoolFees/NewFeesGroup';
import AssignFeesGroup from '../RightBar/SchoolFees/AssignFeesGroup';
import FeesGroupStructure from '../RightBar/SchoolFees/FeesGroupStructure';
import FeesBatch from '../RightBar/SchoolFees/FeesBatch';
import BillingPreview from '../RightBar/SchoolFees/BillingPreview';
import NewFeesDiscount from '../RightBar/SchoolFees/NewFeesDiscount';
import ConfigSpecialAccount from '../RightBar/Config/ConfigSpecialAccount';
import SettleInvoice from '../RightBar/Transaction/SettleInvoice';
import EditFeesGroup from '../RightBar/SchoolFees/EditFeesGroup';
import EditFeesVote from './SchoolFees/EditFeesVote';
import EditGateway from './Config/Gateways/EditGateway';
import EditAccount from '../RightBar/EditAccount';
import EditBatch from './SchoolFees/EditBatch';
import EditVendor from '../RightBar/EditVendor';
import ConfigGymValue from '../RightBar/Config/ConfigGymValue';
import RepositionAccount from '../RightBar/RepositionAccount';
import EditTag from '../RightBar/EditTag';
import EditProfile from './Config/Profile/EditProfile';
import UploadLogo from './Config/Profile/UploadLogo';
import CreateSignatory from './Config/Sign/CreateSignatory';
import EditSignatory from './Config/Sign/EditSignatory';
import EditPreference from './Config/Preference/EditPreference';
import NewBankDeposit from './Banking/NewBankDeposit';
import BsModal from './Common/BsModal';
import { useTheme } from '../DataStore/ThemeContext';
import NewFeesVote from './SchoolFees/NewFeesVote';
import AssignFeesVote from './SchoolFees/AssignFeesVote';
import FeesGroupConfig from '../RightBar/SchoolFees/FeesGroupConfig';
import NewBatch from './SchoolFees/NewBatch';
import NewKeyModal from './Config/Keys/NewKeyModal';
import ChangeSettlementBank from './SchoolFees/ChangeSettlementBank';


const componentMapping = {
    NewTag: NewTag,
    ManageTag: ({ settingData }) => <EditTag projectInfo={settingData} />,
    EditProfile: ({ settingData }) => <EditProfile profile={settingData} />,
    UploadLogo: ({ settingData }) => <UploadLogo logo={settingData} />,
    NewVendor: NewVendor,
    NewAccount: NewAccount,
    AccountSearchResult: ({ settingData }) => <AccountResult account={settingData} />,
    TransactionSearchResult: ({ settingData }) => <TransactionResult transaction={settingData} />,
    VendorSearchResult: ({ settingData }) => <VendorResult vendor={settingData} />,
    ConfigNewUserRole: NewRole,
    ConfigEditUserRole: ({ settingData }) => <UpdateRole role={settingData} />,
    ConfigNewUser: NewUserInvite,
    ConfigNewBank: NewBank,
    ConfigSchoolFees: ({ settingData }) => <ConfigFeesValue field={settingData} />,
    ConfigGateway : ({ settingData }) => <EditGateway gateway={settingData} />,
    SyncStudents: SyncStudents,
    NewFeesGroup: NewFeesGroup,
    NewFeesVote: NewFeesVote,
    NewFeesBatch: NewBatch,
    FeesGroupConfig: ({ settingData }) => <FeesGroupConfig feesGroup={settingData} />,
    AssignVote: ({ settingData }) => <AssignFeesVote feesGroup={settingData} />,
    EditFeesGroup: ({ settingData }) =><EditFeesGroup groupInfo={settingData} />,
    EditFeesVote: ({ settingData }) =><EditFeesVote feesVote={settingData} />,
    AssignFeesGroup: ({ settingData }) =><AssignFeesGroup studentIds={settingData} />,
    FeesStructure: ({ settingData }) => <FeesGroupStructure feesGroup={settingData} />,
    BillingBatch: FeesBatch,
    EditFeesBatch: ({ settingData }) =><EditBatch batchInfo={settingData} />,
    BillingPreview: ({settingData}) => <BillingPreview studentIds={settingData} />,
    CustomBilling: ({settingData}) => <BillingPreview studentIds={settingData} billingType='custom'/>,
    ChangeSettlementBank: ({settingData}) => <ChangeSettlementBank data={settingData} />,
    NewFeesDiscount: ({ settingData }) => <NewFeesDiscount studentIds={settingData} />,
    ConfigSpecialAccount : ({ settingData }) => <ConfigSpecialAccount specialAccount={settingData} />,
    SettleSupplierInvoice : ({ settingData }) => <SettleInvoice invoice={settingData} />,
    EditAccount: ({ settingData }) => <EditAccount account={settingData} />,
    EditVendor: ({ settingData }) => <EditVendor vendorInfo={settingData} />,
    ConfigGym: ({ settingData }) => <ConfigGymValue field={settingData} />,
    RepositionAccount: ({ settingData }) => <RepositionAccount account={settingData} />,
    ConfigNewSignatory: CreateSignatory,
    ConfigEditSignatory: ({ settingData }) => <EditSignatory signatory={settingData} />,
    ConfigEditPreference: ({ settingData }) => <EditPreference preference={settingData} />,
    ConfigNewKey: ({settingData}) => <NewKeyModal tools={settingData} />,

    // checking
    NewBankDeposit:({ settingData }) => <NewBankDeposit settingData={settingData} />,
};

const GlobalSystemModal = memo(({ settingsOpen, closeSettings, settingTitle, settingCode, settingData, buttonLabel, showButtons = true }) => {
    const SelectedComponent = componentMapping[settingCode];
    const {runSystemFunction} = useTheme();
    const [loading, setLoading] = useState(false);

    const handleSave = async() => {
      setLoading(true);
      await runSystemFunction();
      setLoading(false);
    };

    return SelectedComponent ? (
    <BsModal
      show={settingsOpen}
      onClose={closeSettings}
      title={settingTitle}
      size="modal-lg"
      footer={
        showButtons ? (
          <>
            <button type="button" className="btn btn-modern-secondary" onClick={closeSettings} disabled={loading}>
              Close
            </button>

          <button type="button" className="btn btn-modern-primary" onClick={handleSave} disabled={loading}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm mr-2" />
                Saving...
              </>
            ) : (
              <>
                <i className="fa fa-check-circle mr-2"></i> {buttonLabel ? buttonLabel : 'Save Changes'}
              </>
            )}
          </button>
        </>
        ) : null
      }
    >
      <div style={{ padding: '8px' }}>
            {typeof SelectedComponent === 'function' ? <SelectedComponent settingData={settingData} /> : <SelectedComponent />}
      </div>
    </BsModal>
       
    ) : null;
});

export default GlobalSystemModal;
